if (!customElements.get('ia-sticky-product')) {
  class IaStickyProduct extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.mainForm = this.closest('ia-main-product')?.querySelector('ia-product-form');
      this.themeHeader = document.querySelector('.ia-header');

      this.querySelector('button')?.addEventListener('click', this.scrollToTop.bind(this));
      document.addEventListener('scroll', this.onScroll.bind(this));
    }
    onScroll() {
      if (!this.themeHeader || !this.mainForm) return;
      const isMainFormVisible = this.mainForm.getBoundingClientRect().top > this.themeHeader.offsetHeight;
      
      if (isMainFormVisible) {
        this.hide();
      } else {
        this.show();
      }
    }
    show() {
      this.classList.remove('ia-hidden');
      window.iaTheme.hideExtraStickyElements();
    }
    hide() {
      this.classList.add('ia-hidden');
      window.iaTheme.showExtraStickyElements();
    }
    scrollToTop() {
      // window.scrollTo({top: 0, behavior: 'smooth'});
    }
  }
  customElements.define('ia-sticky-product', IaStickyProduct);
}